import { useMemo } from "react";
import { useAudit } from "../../contexts/auditContext";
import {
  controlAnalyticsOwner,
  workStepAnalyticsOwner,
  type AnalyticsOwner,
} from "../../lib/analyticsOwner";

/**
 * The entity a session's analytics reads are addressed by: its control on a
 * control session, its work step on a work-step session. Undefined while the
 * envelope loads, which leaves every analytics read unissued.
 */
export function useSessionAnalyticsOwner(): AnalyticsOwner | undefined {
  const { controlSession, sessionKind } = useAudit();
  const ownerId =
    sessionKind === "work_step"
      ? controlSession?.workStepId
      : controlSession?.controlId;
  return useMemo(
    () =>
      sessionKind === "work_step"
        ? workStepAnalyticsOwner(ownerId)
        : controlAnalyticsOwner(ownerId),
    [sessionKind, ownerId],
  );
}
